import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "style", "full", "LeadingIcon", "renderLeadingIcon", "TrailingIcon", "renderTrailingIcon", "error", "disabled", "sizeType", "autoFocus", "value", "inputElProps", "label"];
import { forwardRef, useEffect, useRef } from 'react';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @deprecated Use the InputField component instead.
 */
export var BaseInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    style = _ref.style,
    _ref$full = _ref.full,
    full = _ref$full === void 0 ? false : _ref$full,
    LeadingIcon = _ref.LeadingIcon,
    renderLeadingIcon = _ref.renderLeadingIcon,
    TrailingIcon = _ref.TrailingIcon,
    renderTrailingIcon = _ref.renderTrailingIcon,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$sizeType = _ref.sizeType,
    sizeType = _ref$sizeType === void 0 ? 'large' : _ref$sizeType,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    value = _ref.value,
    inputElProps = _ref.inputElProps,
    label = _ref.label,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var inputElement = useRef(null);
  var assignRef = function assignRef(el) {
    if (typeof ref === 'function') {
      ref(el);
    } else if (ref) {
      ref.current = el;
    }
    inputElement.current = el;
  };
  useEffect(function () {
    if (autoFocus && inputElement.current) {
      inputElement.current.focus();
    }
  }, [autoFocus]);

  /** Just a little variables to express in a better way the state of the input */
  var notError = !error;
  var enabled = !disabled;
  return /*#__PURE__*/_jsxs("span", {
    style: style,
    className: clsx(className, 'tw-relative tw-block tw-font-body4 ', full ? 'tw-w-full' : 'tw-w-28'),
    children: [renderLeadingIcon ? renderLeadingIcon() : null, LeadingIcon && !renderLeadingIcon && /*#__PURE__*/_jsx("span", {
      className: clsx('tw-absolute tw-left-1.6', {
        'tw-top-1.6': sizeType === 'large',
        'tw-top-0.8': sizeType === 'small'
      }),
      children: /*#__PURE__*/_jsx(LeadingIcon, {
        size: 24,
        className: clsx({
          'tw-text-neutral-light-600 dark:tw-text-neutral-dark-500': notError && enabled,
          'tw-text-alert-400 dark:tw-text-alert-300': error,
          'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600': disabled
        })
      })
    }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread(_objectSpread({}, inputElProps), otherProps), {}, {
      ref: assignRef,
      value: value,
      className: clsx(className, 'tw-w-full tw-rounded-[1rem] tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700 tw-border tw-border-solid dark:tw-text-neutral-light-100 disabled:placeholder:tw-text-neutral-light-500 dark:disabled:placeholder:tw-text-neutral-dark-600 placeholder:tw-text-neutral-light-700 placeholder:dark:tw-text-neutral-dark-500 focus:tw-outline-none focus:tw-border-[0.1rem] disabled:tw-bg-neutral-light-400 dark:disabled:tw-bg-neutral-dark-500 disabled:tw-text-neutral-light-500 dark:disabled:tw-text-neutral-dark-600',
      // Add or remove padding if the leading and trailing icon are present.
      LeadingIcon ? 'tw-pl-[5.2rem]' : 'tw-pl-1.6', TrailingIcon ? 'tw-pr-[5.2rem]' : 'tw-pr-1.6', error ? 'tw-border-alert-400 dark:tw-border-alert-300' : 'tw-border-neutral-light-500 focus:tw-border-primary-light-500 dark:focus:tw-border-primary-dark-300 active:tw-border-primary-light-500 dark:active:tw-border-primary-dark-300 disabled:tw-border-none', {
        'tw-h-5.6 tw-py-1.6': sizeType === 'large',
        'tw-h-4 tw-py-0.8': sizeType === 'small',
        'tw-cursor-not-allowed': disabled
      }),
      disabled: disabled,
      "aria-label": label
    })), renderTrailingIcon ? renderTrailingIcon() : null, TrailingIcon && !renderTrailingIcon && /*#__PURE__*/_jsx("span", {
      className: clsx('tw-absolute tw-right-1.6', {
        'tw-top-1.6': sizeType === 'large',
        'tw-top-0.8': sizeType === 'small'
      }),
      children: /*#__PURE__*/_jsx(TrailingIcon, {
        size: 24,
        className: clsx({
          'tw-text-neutral-light-600 dark:tw-text-neutral-dark-500': notError && enabled,
          'tw-text-alert-400 dark:tw-text-alert-300': error,
          'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600': disabled
        })
      })
    })]
  });
});
BaseInput.displayName = 'BaseInput';
export default BaseInput;